<template>
    <div class="mb-4">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <label v-if="segundaOpcionCreada" class="d-flex justify-content-center mt-4">PTI opción {{ index + 1 }}</label>
        <b-row class="mt-3 text-center mb-3">
            <b-col>
                <p class="headers">Tratamiento</p>
            </b-col>
            <b-col cols="2">
                <p class="headers">Cantidad</p>
            </b-col>
            <b-col cols="2" v-if="mastrarPrecio">
                <p class="headers">Precio unitario</p>
            </b-col>
            <b-col :cols="segundaOpcionCreada ? 2 : 1" align="right">
                <div class="d-flex" style="margin-top: -10px;">
                    <div>
                        <b-button style="width: 30%;"
                            v-if="!disable"
                            v-b-tooltip.hover title="Agregar Tratamiento"
                            variant="link"
                            @click="agregarTratamiento()">
                            <font-awesome-icon icon="plus-circle"/>
                        </b-button>
                    </div>
                    <div>
                        <b-dropdown v-if="!disable" id="dropdown-1" dropleft size="sm" variant="link" class="m-md-2"
                                toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <font-awesome-icon icon="ellipsis-v"/>
                        </template>
                        <b-dropdown-group id="dropdown-group-1" header="Paquetes">
                            <b-dropdown-item v-if="paquetes.paquete1 !== undefined && paquetes.paquete1.length > 0" @click="cambiarPaquete(paquetes.paquete1)">tratamientos sugeridos 1</b-dropdown-item>
                            <b-dropdown-item v-if="paquetes.paquete2 !== undefined && paquetes.paquete2.length > 0" @click="cambiarPaquete(paquetes.paquete2)">tratamientos sugeridos 2</b-dropdown-item>
                            <b-dropdown-item v-if="paquetes.paquete3 !== undefined && paquetes.paquete3.length > 0" @click="cambiarPaquete(paquetes.paquete3)">tratamientos sugeridos 3</b-dropdown-item>
                        </b-dropdown-group>
                        <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item @click="limpiar()">
                        <b-icon-trash></b-icon-trash>
                        Limpiar
                      </b-dropdown-item>
                      <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="mastrarPrecio = !mastrarPrecio">
                          <span v-if="mastrarPrecio">Ocultar</span>
                          <span v-else>Mostrar</span>
                              precios (no incluye descuento de plan ni promociones)
                        </b-dropdown-item>
                    </b-dropdown>
                    </div>
                </div>
            </b-col>
        </b-row>
        <hr style="margin-top: -2%;">
        
        <div v-if="tratamientos.length > 0">
            <loading :active.sync="loadTrt" :can-cancel="false" :is-full-page="false"></loading>
            <div v-for="(item, i) in tratamientos" :key="'tratamiento' + i">
                <b-row class="d-flex justify-content-center align-items-center">
                    <b-col>
                        <div class="d-flex align-items-center">
                            <SelectTratamientos
                            style="width: 100%;"
                            :indexPadecimiento="indexTarjeta"
                            :indexOpcion="index"
                            :catalogoTratamientos="catTratamientos"
                            :catalogokits="catalogokits"
                            :idSeleccionado="item.idTratamiento"
                            :tratamiento="item"
                            :tratamientos="tratamientos"
                            :i="i"
                            :kits="true"
                            ></SelectTratamientos>
                            <em v-b-tooltip.hover.topleft.v-light
                                title="Ver argumentario"
                                class="info_padecimiento ml-2"
                                style="position: relative !important; margin-bottom: -3px; cursor: pointer; width: 1em;"
                                v-if="item.argumentarioCompleto"
                                @click="verArgumentario(item.idTratamiento,item.nombreTratamiento,item.listaTratamientos ? item.listaTratamientos : [])">
                            </em>
                        </div>
                    </b-col>
                    <b-col cols="2" align="center">
                        <b-input min="1" v-if="item.idKit == null"
                            type="number" v-model="item.cantidad">
                        </b-input>
                        <span v-else>{{item.cantidad}}</span>
                    </b-col>
                    <b-col cols="2" class="text-center" v-if="mastrarPrecio">
                        <div style="font-weight: bolder; color: #3F78A1;">
                            <p v-if="item.precio" style="font-size: .9em;">{{item.precio | moneda}}</p>
                            <p v-else>-</p>
                        </div>
                    </b-col>
                    <b-col :cols="segundaOpcionCreada ? 2 : 1" class="pr-1 pl-1">
                        <b-button v-if="item.idKit !== null && item.idKit !== undefined" @click="obtenerImagenKit(item.idKit)" v-b-toggle="item.idKit+'t'+i+'ind'"
                            variant="outline-info" size="sm" class="mr-1 mt-1 marginbotones" style="max-width: 1.8vw; max-height: 2vw;">
                            <b-icon icon="chevron-down" font-scale="1.1"></b-icon>
                        </b-button>
                        <b-button size="sm" v-b-tooltip.hover title="Eliminar Tratamiento"
                            style="color: red !important;" variant="link"
                            @click="eliminarTratamiento(item)">
                            <font-awesome-icon icon="times-circle"/>
                        </b-button>
                    </b-col>
                </b-row>
                <b-collapse :id="item.idKit+'t'+i+'ind'" accordion="my-accordion"
                    role="tabpanel">
                    <b-row>
                        <b-col cols="3" class="pr-0" v-if="imagenKit != null && !segundaOpcionCreada">
                            <img :src="'data:image/png;base64,' + imagenKit " alt="img" style="height: 240px"/>
                        </b-col>
                        <b-col class="p-0">
                            <b-row class="ml-0 mr-2" style="color: gray;" v-for="(trt,indexTratamiento) in item.listaTratamientos" :key="indexTratamiento">
                                <b-col cols="1"><em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em></b-col>
                                <b-col align="left" :class="imagenKit!=null && !segundaOpcionCreada ? 'p-0' : 'p-0'" :cols="imagenKit!=null && !segundaOpcionCreada ? mastrarPrecio?4:7 : mastrarPrecio?6:8"><span>{{ trt.nombreTratamiento }}</span></b-col>
                                <b-col :cols="imagenKit!=null && !segundaOpcionCreada ? 2 : 1" :class="imagenKit!=null && !segundaOpcionCreada ? mastrarPrecio ? 'text-right ml-0 pl-0' : 'text-center ml-4 pr-0' : mastrarPrecio ? 'text-left ml-0 p-0' : 'text-center ml-3'"><span>{{ trt.cantidad }}</span></b-col>
                                <b-col :cols="imagenKit!=null && !segundaOpcionCreada ? 5 : 3" :class="imagenKit!=null && !segundaOpcionCreada ? 'text-center pl-1' : 'text-center p-0'" v-if="mastrarPrecio">
                                    <div style="font-weight: bolder; color: #3F78A1;">
                                        <p v-if="trt.precio" style="font-size: .9em;">{{trt.precio | moneda}}</p>
                                        <p v-else>-</p>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-collapse>
            </div>
        </div>
        <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 15vh;">
                <p>Sin tratamientos agregados</p>
        </div>
        <b-modal
            size="lg"
            v-model="mostrarArgumentarioTx"
            scrollable
            hide-footer
            hide-header
        >
            <div style="display: flex;width: 100%;" class="mb-3">
            <div class="d-flex align-items-center detalle-formulario">
                <span class="detalle-formulario-h1 ml-3"
                    style="font-size: 20px; font-weight: bolder !important; color: var(--color-dentalia) !important;">
                Argumentario: {{datosArgumentarioTx.nombreTx}}
                </span>

            </div>
            <b-button class="button-dentalia-svg-4 mr-2" variant="primary"
                        @click="mostrarArgumentarioTx = false">
                <em class="close_x_svg icon-dentalia-svg-0" style="height: 16px; "></em>
            </b-button>
            </div>


        <ModalArgumentario v-if="mostrarArgumentarioTx"
                                :idTratamiento="datosArgumentarioTx.idTx"
                                :nombreTratamiento="datosArgumentarioTx.nombreTx"
                                :listaTrtConArgumentario="datosArgumentarioTx.listaTrtConArgumentario"/>
        </b-modal>
    </div>
</template>

<script>
import SelectTratamientos from "./SelectTratamientos.vue";
import ModalArgumentario from "../../views/argumentario/ModalArgumentario.vue";
export default {
    name: "HDTratamientos",
    components: {
        SelectTratamientos,
        //InformacionArgumentario,
        ModalArgumentario
    },
    props: {
        contraerCard: Boolean,
        disable: {
            type: Boolean,
            default: false
        },
        paquetes: null,
        tratamientos: null,
        catTratamientos: null,
        catalogokits: null,
        index: Number,
        indexTarjeta: Number,
        idPadecimiento: Number,
        segundaOpcionCreada: Boolean
    },
    data: () => {
        return {
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
            old: null,
            newData:null,
            mastrarPrecio: false,
            mostrarArgumentarioTx: false,
            datosArgumentarioTx: [],
            imagenKit: null,
            loadTrt: false,
        }
    },
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
        cambiarPaquete(item) {
            this.$emit('cambiarPaquete', this.index, item)
        },
        agregarTratamiento() {
            const item = {idTratamiento: null, cantidad: 1, modificado: true, collapseOpen: false, idKit: null}
            this.tratamientos.push(JSON.parse(JSON.stringify(item)))
            this.$emit('padecimientoModificado')
        },
        eliminarTratamiento(item) {
            this.tratamientos.splice(this.tratamientos.indexOf(item), 1)
            this.$emit('padecimientoModificado')
        },
        limpiar() {
            this.tratamientos.forEach(tratamiento => {
                tratamiento.idTratamiento = null;
                tratamiento.cantidad =  1;
                tratamiento.nombreTratamiento = "";
                tratamiento.precio = null;
            });
        },
        verArgumentario(idTx, nombre, kit){
          console.log({ idTx, nombre, kit });
          if(kit.length > 0){
            kit.forEach((k,i)=>{
              k.seleccionado = i === 0;
            })
            kit = kit.filter(k=>k.argumentarioCompleto);
          }
            this.datosArgumentarioTx.idTx = kit.length > 0 ? kit[0].idTratamiento : idTx;
            this.datosArgumentarioTx.nombreTx =  nombre;
            this.datosArgumentarioTx.listaTrtConArgumentario = kit;
            this.mostrarArgumentarioTx = true;
        },
        obtenerImagenKit(idKit){
            this.loadTrt = true;
            this.imagenKit = null;
            const parametros = {idKit: idKit}
            this.$http.post(this.$api + "version5/ptipresuntivo/obtener/imagenKit", parametros).then(response=>{
                this.loadTrt = false;
                this.imagenKit = response.data.data.imagenKit;
            })
        }
    }
}
</script>

<style scoped>
label {
    color: rgb(50, 50, 50) !important;
}

.headers{
    color: #7A7A7A;
    font-weight: 500;
    font-size: .9em;
}

</style>
